import { render, staticRenderFns } from "./ItemSetIconUrlDialog.vue?vue&type=template&id=85afa432&scoped=true&"
import script from "./ItemSetIconUrlDialog.vue?vue&type=script&lang=ts&"
export * from "./ItemSetIconUrlDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85afa432",
  null
  
)

export default component.exports